import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "@/langs/useTranslation";
import {
  useGlobalState,
  useGlobalDispatch,
  getCurrentCompanyId
} from "../../GlobalProvider";
// import { Button } from "@material-ui/core"
import { Button, Checkbox, Form, Input, message, Select, Spin } from "antd";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import _ from "lodash";
import { getStoreDetailApi } from "@/apis/apiCollection";
import localforage from "localforage";
import modalConfirm from "@/components/Modal/modalConfirm";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@/components/Modal";

const storeDetailStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    padding: "20px",
    "& .form-box": {
      padding: "0px 32px 10px 32px",
      boxSizing: "border-box",
      flex: 1,
      overflowY: "scroll",
      "& .group-name-box": {
        height: "20px",
        borderLeft: "solid 4px #00a6be",
        paddingLeft: "10px",
        fontSize: 16,
        "& .group-name": {
          height: "100%"
        }
      },
      "& .ant-form.ant-form-vertical": {
        paddingTop: "20px"
      },
      "& .ant-form-item-box": {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
        width: "100%",
        fontSize: 14
      },
      "& .ant-form-item": {
        width: "48%",
        "& input": {
          height: "32px"
        }
      },

      "& .ant-form-item-box-one": {
        width: "100%",
        "& .ant-form-item": {
          width: "100%"
        },
        "&.address-form-item": {
          "& .ant-form-item": {
            marginBottom: "5px"
          }
        },
        "& .select-address": {
          width: "100%",
          height: "32px",
          backgroundColor: "white",
          color: "#00AFC6",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          paddingLeft: "10px",
          border: "solid 1px #DDDDDD"
        }
      },

      "& .sale-time-box": {
        marginTop: "20px",
        minHeight: "200px",
        width: "50%",
        backgroundColor: "#f7f8fb",
        borderRadius: "10px",
        padding: "20px 15px 0 20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& .sale-time-box-item": {
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "space-between",
          paddingBottom: "10px",
          boxSizing: "border-box",
          "& .week-value": {
            width: "60px"
          },
          "& .time-value": {
            flex: 1,
            maxWidth: "365px",
            wordBreak: "break-all"
          },
          "& .edit-icon": {
            cursor: "pointer"
          }
        }
      }
    }
  }
}));

const defaultBusinessHoursArr = [
  {
    value: 1,
    is24Hours: false, // 24小时营业
    isRest: false, // 休息
    timeList: []
  },
  {
    value: 2,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 3,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 4,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    value: 5,
    is24Hours: false,
    isRest: false,
    timeList: []
  },
  {
    is24Hours: false,
    isRest: false,
    value: 6,
    timeList: []
  },
  {
    is24Hours: false,
    isRest: false,
    value: 0,
    timeList: []
  }
];

const StoreDetail = ({ groupId, open, onClose }) => {
  const { t } = useTranslation("store");
  const storeStatusArr = [
    { name: t("status.not_yet_opened"), id: "0" },
    { name: t("status.open"), id: "1" },
    { name: t("status.stop"), id: "2" },
    { name: t("status.close"), id: "3" }
  ];

  const WeekValueMap = [
    t("week.Sunday"),
    t("week.Monday"),
    t("week.Tuesday"),
    t("week.Wednesday"),
    t("week.Thursday"),
    t("week.Friday"),
    t("week.Saturday")
  ];

  const displayTime = item => {
    const timeList = item.timeList;
    if (item.is24Hours) return t("open_all_day");
    if (item.isRest) return t("rest");
    let strArr = [];
    _.map(timeList, item => {
      strArr.push(item.start + "~" + item.end);
    });
    return _.join(strArr, ",");
  };

  const [state, setState] = useState({
    BusinessHoursArr: defaultBusinessHoursArr,
    showEditBusinessHoursDialog: false,
    selectWeekIndex: 0,
    CacheData: [],
    showStoreEditMapModal: false,
    addressArr: {
      store_address: "",
      lat: "",
      long: ""
    }
  });
  const [storeInfo, setStoreInfo] = useState({});
  const [formDisabled, setFormDisabled] = useState(true);
  // 使用 formik 库 https://formik.bootcss.com/api/useFormik.html

  // const [formItem,setFormItem ] = useState(defaultFormValues)

  const [form] = Form.useForm();

  const storeDetailStyleClass = storeDetailStyles();
  // 本组件相关方法
  const StoreDetailFunc = {
    getCompanyId: async () => {
      const user_company_id = await localforage.getItem("userCompanyID");
      const company_id = await getCurrentCompanyId();
      return company_id ? company_id : user_company_id;
    },
    getDetail: async () => {
      const company_id = await StoreDetailFunc.getCompanyId();
      const res = await getStoreDetailApi({
        company_id: company_id,
        id: groupId
      });
      const groupInfo = res.group;
      const storeInfo = groupInfo.info;
      setStoreInfo(storeInfo);
      let fieldValue = {
        name: groupInfo.name
      };
      if (storeInfo) {
        fieldValue = {
          name: groupInfo.name, // 门店名称
          store_name: storeInfo.store_name, // 门店简称
          store_code: storeInfo.store_code,
          status: storeInfo.status,
          status_name: storeStatusArr[storeInfo.status]
            ? storeStatusArr[storeInfo.status].name
            : t("unknown"),
          contact: storeInfo.contact,
          contact_phone: storeInfo.contact_phone,
          contact_email: storeInfo.contact_email,
          charge: storeInfo.charge,
          charge_phone: storeInfo.charge_phone,
          charge_email: storeInfo.charge_email,
          store_address: storeInfo.store_address,
          location_address: storeInfo.location_address,
          lat: storeInfo.lat,
          long: storeInfo.lng,
          remark: storeInfo.remark
        };
        setState({
          ...state,
          BusinessHoursArr: storeInfo.business_hours && storeInfo.business_hours.length > 0 ? storeInfo.business_hours : defaultBusinessHoursArr,
          addressArr: {
            store_address: storeInfo.store_address,
            lat: storeInfo.lat,
            long: storeInfo.lng
          }
        });
      }
      form.setFieldsValue(fieldValue);
    }
  };

  useEffect(() => {
    if (!open) return;
    if (!groupId || groupId.length <= 0 || groupId === "all") {
      return;
    }
    setFormDisabled(true);
    StoreDetailFunc.getDetail();
  }, [groupId, open]);

  const DetailBox = () => {
    return (
      <div className={`${storeDetailStyleClass.root} store-detail-box`}>
        <div className={`form-box`}>
          <div className={`group-name-box`}>
            <div className={`group-name`}>{t("basic_information")}</div>
          </div>
          <Form
            name="basic"
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 24 }}
            initialValues={{ remember: true }}
            autoComplete="off"
            labelAlign="left"
            layout="vertical"
            form={form}
            disabled={formDisabled}
          >
            <div className={`ant-form-item-box`}>
              <Form.Item label={`${t("detail.name")}:`} name="name">
                <Input placeholder="" />
              </Form.Item>
              <Form.Item label={`${t("detail.store_name")}:`} name="store_name">
                <Input placeholder="" />
              </Form.Item>
            </div>
            <div className={`ant-form-item-box`}>
              <Form.Item label={`${t("detail.store_code")}:`} name="store_code">
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                label={`${t("detail.status_name")}:`}
                name="status_name"
              >
                <Input placeholder="" />
              </Form.Item>
            </div>

            <div className={`ant-form-item-box`}>
              <Form.Item label={`${t("detail.contact")}:`} name="contact">
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                label={`${t("detail.contact_phone")}:`}
                name="contact_phone"
              >
                <Input placeholder="" />
              </Form.Item>
            </div>

            <div className={`ant-form-item-box`}>
              <Form.Item label={`${t("detail.charge")}:`} name="charge">
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                label={`${t("detail.charge_phone")}:`}
                name="charge_phone"
              >
                <Input placeholder="" />
              </Form.Item>
            </div>

            <div className={`ant-form-item-box`}>
              <Form.Item
                label={`${t("detail.contact_email")}:`}
                name="contact_email"
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                label={`${t("detail.charge_email")}:`}
                name="charge_email"
              >
                <Input placeholder="" />
              </Form.Item>
            </div>

            <div className={`ant-form-item-box-one address-form-item`}>
              <Form.Item
                label={`${t("detail.store_address")}:`}
                name="store_address"
              >
                <Input placeholder="" />
              </Form.Item>
            </div>
            <div className={`ant-form-item-box-one`}>
              <Form.Item label="" name="location_address">
                <Input placeholder="" />
              </Form.Item>
            </div>

            <div className={`ant-form-item-box-one`}>
              <Form.Item label={`${t("detail.remark")}:`} name="remark">
                <Input placeholder="" />
              </Form.Item>
            </div>
          </Form>

          <div className={`group-name-box`}>
            <div className={`group-name`}>{`${t(
              "detail.business_hours"
            )}:`}</div>
          </div>

          <div
            className={`sale-time-box`}
            style={{ pointerEvents: formDisabled ? "none" : "auto" }}
          >
            {state.BusinessHoursArr.map((item, index) => {
              return (
                <div className={`sale-time-box-item`} key={index}>
                  <div className={`week-value`}>{WeekValueMap[item.value]}</div>
                  <div className={`time-value`}>{displayTime(item)}</div>
                  <div className={`edit-icon`}>
                    {/*<EditOutlinedIcon fontSize="small" style={{color: "#00a6be"}}></EditOutlinedIcon>*/}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        title={t({ defaultMessage: "查看门店信息" })}
        width={1000}
        open={open}
        onClose={onClose}
        showConfirm={false}
        showCancel={false}
      >
        <DetailBox />
      </Modal>
    </>
  );
};

export default StoreDetail;
